import {Button, Card, Typography} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {Book} from "../../../../../shared/types/api";
import {useState} from "react";
import Constants from "../../../../../const/Constants";

const {Text} = Typography;

const CatalogBookCard: React.FC<{ book: Book, addToLibrary: (book: Book) => Promise<void> }> = ({book, addToLibrary}) => {

    const [loading, setLoading] = useState<boolean>(false);

    const handleAdd = () => {
        setLoading(true);
        addToLibrary(book).finally(() => setLoading(false));
    }

    const coverSrc = book.coverId ? `${Constants.queryConst}/file/book/cover/image?id=${book.coverId}` : '../images/books/nocover.png'

    return (
        <Card
            title={book.title}
            style={{width: 300, margin: 16}}
            hoverable
            cover={
                <div
                    style={{
                        height: 308,
                        width: 200,
                        overflow: "hidden",
                        paddingTop: 8,
                        margin: "0 auto",
                        borderRadius: 12,
                    }}
                >
                    <img
                        src={coverSrc}
                        alt="Cover"
                        loading="lazy"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8
                        }}
                    />
                </div>}
            actions={[
                <Button
                    type="link"
                    loading={loading}
                    onClick={handleAdd}
                    icon={<PlusOutlined/>}
                >
                    Добавить в библиотеку
                </Button>,
            ]}
        >
            <Text><strong>Автор(ы):</strong> {book.authors?.join(', ')}</Text><br/>
            <Text><strong>Язык:</strong> {book.language}</Text><br/>
        </Card>
    )
}

export default CatalogBookCard